module.exports = __webpack_public_path__ + "img/2025big24.eac6fe01.jpg";